import React from "react";
import { ImageProps } from "types/Image";

interface LogoSvgProps extends ImageProps {
  width?: string;
  height?: string;
  className?: string;
}

const LogoSvg: React.FC<LogoSvgProps> = ({
  width = "300",
  height = "50",
  className = "h-10 w-auto object-contain",
  fetchPriority = "high",
  skipLazy = true,
}) => {
  const base = import.meta.env.BASE_URL || "/";
  const imgUrl = `${base.endsWith("/") ? base : base + "/"}logo.png`;

  return (
    <img
      src={imgUrl}
      alt="DZ Insights Logo"
      height={height}
      width={width}
      className={className}
      style={{ aspectRatio: "300 / 50" }}
      decoding="async"
      {...{ fetchpriority: fetchPriority }}
      loading={skipLazy ? "eager" : "lazy"}
    />
  );
};

export default LogoSvg;
